import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { mapGridIndexes } from '@shared/commonFunctions';
import { SaveButton } from '@shared/components/SaveButton';
import { IRoleUser } from '@shared/interfaces';
import { ShadowDivider } from '@shared/styledComponents';
import { excludedRowClassName, RoleModalSectionHeader } from '@styles/Admin-tools/Roles/RoleModalStyles';

import { Wrapper } from '@styles/CommonStyles';
import { roleUsersColumns } from '..';

interface IUsersFinalSetProps {
  roleName: string;
  data: IRoleUser[];

  onSave(): void;
}

export const UsersFinalSet = ({ roleName, data, onSave }: IUsersFinalSetProps) => {
  return (
    <>
      <RoleModalSectionHeader>Final User Set for "{roleName}" Role</RoleModalSectionHeader>

      <SaveButton top="15px" right="15px" width="80px" onClick={onSave} />

      <ShadowDivider />
      <Wrapper>
        <PhoenixGrid
          disableSelectionOnClick
          autoHeight
          pageSize={15}
          columns={roleUsersColumns}
          rows={mapGridIndexes(data)}
          getRowClassName={excludedRowClassName}
        />
      </Wrapper>
    </>
  );
};
